import axios from 'axios';

export const popularDestinationsService = {
  getPopularDestinations: () => axios.get('/popular-destinations', { token: false }),
};
